import { Modal } from "antd";
import { get } from "lodash";
import View from "./View";

const Profile = ({ open, project, updateStatus, onClose }) => {
  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={440}
      className="acoris-profile-modal"
    >
      <View
        contact={{ ...get(project, "contact", {}) }}
        onClose={onClose}
        updateProjectStatus={updateStatus}
      />
    </Modal>
  );
};

export default Profile;
